<template>
  <section>
    <base-section-title>#{{$t('homepage.contact.title')}}'</base-section-title>
    <div>
      <p class="font-bold py-5 text-center">{{$t('homepage.contact.content')}}</p>
    </div>
    <div class="grid gird-cols-1 md:grid-cols-2">
      <div class="flex items-center justify-center">
        <ul>
          <li><i class="fas fa-phone"></i> +2126-2331-8499</li>
          <li><i class="fas fa-envelope-open-text"></i> drissouhbibcontact@gmail.com</li>
        </ul>
      </div>
      <contact-form />
    </div>
  </section>
</template>

<script>
import BaseSectionTitle from '../../base/BaseSectionTitle'
import ContactForm from '../../forms/ContactForm'
export default {
  name: 'ContactSection',
  components: { ContactForm, BaseSectionTitle }
}
</script>

<style scoped>

</style>
